import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderStyle } from 'pages/layout/Header.style';
import clsx from 'clsx';

import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';
import { Button } from 'components';
import HeaderProfile from './HeaderProfile';

export default function BeforeLoginHeader() {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos, visible]);

  const handleNavigatetoHome = () => {
    navigate('/');
    window.scroll(0, 0);
  };

  return (
    <HeaderStyle className={clsx(!visible && 'hidden')}>
      <header className="header">
        <div className="header-container">
          <div className="header-brand" onClick={handleNavigatetoHome}>
            <WafyNetLogo />
            <h3 className="logo-title">WafyNet</h3>
          </div>
        </div>
        <div className="header-auth-btn">
          <Button
            type="outlined"
            label={'Log In'}
            onClick={() => navigate('/login')}
          />
          <Button label={'Sign Up'} onClick={() => navigate('/signup')} disableElevation />
        <HeaderProfile />
        </div>
      </header>
    </HeaderStyle>
  );
}
